import axios from "axios";
 
// Localhost
// let domain = "http://localhost:5001/";  // Localhost
// let domain = "http://1.23.242.234:7002/";  // QA
let domain = "https://dop-gpdp.austere.biz/";   // Live
 
const instance = axios.create({
  baseURL: domain + "api",
  timeout: 90000, // 90 second timeout (client should wait longest)
  withCredentials: true, // Important for session cookies
});
 
const baseUrl = () => {
  return domain;
};
 
export default instance;
export { baseUrl };